import { routes as dashboardRoutes } from 'packages/dashboard';
import { routes as eventRoutes } from 'packages/events';
import { routes as eventTypesRoutes } from 'packages/eventTypes';
import { routes as groupsRoutes } from 'packages/groups';
import { routes as locationsRoutes } from 'packages/locations';
import { routes as schedulesRoutes } from 'packages/schedules';
import { routes as checkpointRoutesRoutes } from 'packages/checkpointRoutes';
import { routes as usersRoutes } from 'packages/users';
import { routes as homeRoutes } from 'packages/home';
import { routes as profileRoutes } from 'packages/profile';
import { routes as operationalPanelRoutes } from 'packages/operationalPanel';
import { routes as triggersRoutes } from 'packages/triggers';
import { routes as userPositionHistoryRoutes } from 'packages/reports';
import { routes as workTemplateRoutes } from 'packages/workTemplates';
import { routes as workOrderRoutes } from 'packages/workOrders';
import { routes as monitoringRoutes } from 'packages/monitoring';
import { routes as positionRoutes } from 'packages/jobs';
import { routes as optionListRoutes } from 'packages/optionLists';
import { routes as costCenterRoutes } from 'packages/costCenters';
import { routes as externalCompaniesRoutes } from 'packages/externalCompanies';

import { routes as shiftsRoutes } from 'packages/shifts';
import { routes as workJourneyRoutes } from 'packages/workJourney';
import { routes as addressesRoutes } from 'packages/addresses';
import { routes as holidaysRoutes } from 'packages/holidays';
import { routes as absencesRoutes } from 'packages/absences';
import { routes as operondaApiRoutes } from 'packages/operondaApi';
import { routes as workDirectionRoutes } from 'containers/App/TimeTracker/Main';
import { routes as documentRequestsRoutes } from 'packages/documentRequests';
import { routes as emergencyRoutes } from 'packages/emergencies';
import { routes as workerScoreRoutes } from 'packages/workerScore';

/**
 * Every route `AuthRoute` mounts, in match order. Exported so
 * `appRoutes.access.guard.test.ts` asserts over the same array the app renders
 * instead of a copy that can drift.
 *
 * Order matters for access: an ungated route that shadows a gated one bypasses
 * its gate. Keep `homeRoutes` last (see comment below).
 */
export const ROUTES_LIST = [
  ...workDirectionRoutes,
  ...shiftsRoutes,
  ...workJourneyRoutes,
  ...addressesRoutes,
  ...holidaysRoutes,
  ...emergencyRoutes,
  ...operondaApiRoutes,
  ...absencesRoutes,
  ...externalCompaniesRoutes,
  ...positionRoutes,
  ...optionListRoutes,
  ...costCenterRoutes,
  ...monitoringRoutes,
  ...userPositionHistoryRoutes,
  ...workOrderRoutes,
  ...workTemplateRoutes,
  ...triggersRoutes,
  ...dashboardRoutes,
  ...workerScoreRoutes,
  ...eventRoutes,
  ...eventTypesRoutes,
  ...groupsRoutes,
  ...locationsRoutes,
  ...checkpointRoutesRoutes,
  ...schedulesRoutes,
  ...usersRoutes,
  ...profileRoutes,
  ...documentRequestsRoutes,
  ...operationalPanelRoutes,
  // Before homeRoutes: home uses path '' without exact and would otherwise match every /:orgId/-/… URL first.
  ...homeRoutes,
];

export default ROUTES_LIST;
